<div class="employee-cat-component-container page-root-container">
    <div class="page-header">
        <div class="page-title">
            <mat-icon class="icon">settings_accessibility</mat-icon><span class="title">Employee Status</span>
        </div>
    </div>

    <div class="data-container">
        <app-loader [show]="isLoading"></app-loader>
        <app-search-filter #searchFilter [pagingData]="pagingData" [pageSizeOptions]="[5,10,20,50,100]" [filter]="filter" (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)" [hidePageSize]="true">
        </app-search-filter>

        <section tabindex="0" class="table-container">
            <table matSort mat-table [dataSource]="dataSource" (matSortChange)="sortData($event)">
                <ng-container matColumnDef="code">
                    <th mat-sort-header="code" mat-header-cell *matHeaderCellDef>Code</th>
                    <td mat-cell *matCellDef="let item">{{item.code}}</td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-sort-header="name" mat-header-cell *matHeaderCellDef>Name</th>
                    <td mat-cell *matCellDef="let item">{{item.name}}</td>
                </ng-container>

                <ng-container matColumnDef="is_active_status">
                    <th mat-sort-header="is_active_status" mat-header-cell *matHeaderCellDef>Active Status</th>
                    <td mat-cell *matCellDef="let item">
                        <mat-icon>{{item.is_active_status ? 'check_circle' : 'cancel'}}</mat-icon>
                    </td>
                </ng-container>

                <ng-container matColumnDef="notice_period_1">
                    <th mat-sort-header="notice_period_1" mat-header-cell *matHeaderCellDef>Notice 1 (Days)</th>
                    <td mat-cell *matCellDef="let item">{{item.notice_period_1}}</td>
                </ng-container>

                <ng-container matColumnDef="notice_period_2">
                    <th mat-sort-header="notice_period_2" mat-header-cell *matHeaderCellDef>Notice 2 (Days)</th>
                    <td mat-cell *matCellDef="let item">{{item.notice_period_2}}</td>
                </ng-container>

                <ng-container matColumnDef="send_notification">
                    <th mat-sort-header="send_notification" mat-header-cell *matHeaderCellDef>Notify</th>
                    <td mat-cell *matCellDef="let item">
                        <mat-icon>{{item.send_notification ? 'notifications_active' : 'notifications_off'}}</mat-icon>
                    </td>
                </ng-container>

                <ng-container matColumnDef="action" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell class="row-menu-btn" style="width:50px" *matCellDef="let item">
                        <a mat-icon-button class="row-menu-btn" [matMenuTriggerFor]="rowMenu" (click)="onRowSelected(item);$event.stopPropagation();">
                            <mat-icon>more_vert</mat-icon>
                        </a>
                        <mat-menu #rowMenu>
                            @if(permission.can_delete){
                            <button mat-menu-item (click)="onDelete(item)">Delete</button>
                            }
                            @if(permission.can_edit){
                            <button mat-menu-item (click)="onEdit(item)">Edit</button>
                            }@else{
                            <button mat-menu-item (click)="onEdit(item)">View</button>
                            }
                        </mat-menu>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row class="table-element-row" *matRowDef="let item; columns: displayedColumns;" (click)="onRowSelected(item)" (dblclick)="onEdit(item)" [ngClass]="{'row-selected': item.id===selectedItem?.id}"></tr>
            </table>
        </section>

        @if(pagingData.length<=0){
        <div class="no-data-container">
            <img src="assets/images/no-data.png">
            <span class="no-data-info">No data found. Please remove or redefine the filters if any.</span>
        </div>
        }
    </div>
</div>
